<div fxLayout="column">
  <!-- IE requires all fxLayout="column" elements to have the child contents wrapped in a plain div tag -->
  <div *ngIf="isBrowserIE; else homePageFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
    <ng-container *ngTemplateOutlet="homePageFlexColumnTemplate"></ng-container>
  </div>
</div>

<ng-template #homePageFlexColumnTemplate>
  <div fxFlex.lt-sm="10px" fxFlex.gt-sm="25px">&nbsp;</div>
  <div fxFlex="100%" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap.lt-md="10px">
    <div *ngIf="isBrowserIE && media.isActive('lt-md'); else homePageMainFlexColumnTemplate">
      <ng-container *ngTemplateOutlet="homePageMainFlexColumnTemplate"></ng-container>
    </div>
  </div>
  <div fxFlex.lt-md="10px" fxFlex.gt-sm="25px">&nbsp;</div>
</ng-template>

<ng-template #homePageMainFlexColumnTemplate>
  <div fxFlex="5%" fxHide.lt-md></div>
  <div fxFlex="90%" ngStyle.lt-md="padding-left: 8px; padding-right: 8px" *ngIf="!showSpinner">
    <div class="display-text normal-paragraph-spacing">
      <mat-card>
        <mat-card-content>
          <div fxLayout="column">
            <div *ngIf="isBrowserIE; else homePageHeaderFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
              <ng-container *ngTemplateOutlet="homePageHeaderFlexColumnTemplate"></ng-container>
            </div>
          </div>
          <div fxLayout="column">
            <div *ngIf="isBrowserIE; else homePageMessagesFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
              <ng-container *ngTemplateOutlet="homePageMessagesFlexColumnTemplate"></ng-container>
            </div>
          </div>
          <div fxLayout="column">
            <div *ngIf="isBrowserIE; else homePageFooterFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
              <ng-container *ngTemplateOutlet="homePageFooterFlexColumnTemplate"></ng-container>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
  <div fxFlex="5%" fxHide.lt-md></div>
</ng-template>

<ng-template #homePageHeaderFlexColumnTemplate>
  <div fxLayout="column">
    <div class="display-text primary-dark-color-important" *ngIf="userFullName.length > 0">
      <span style="white-space: nowrap !important;" fxLayoutAlign="start center">
        <b>{{ userFullName }}</b>
      </span>
    </div>
    <div class="display-text primary-dark-color-important">
      <span style="white-space: nowrap !important;" fxLayoutAlign="start center">
        <b
          ><span i18n="@@home-page.header.participant-id.label">home-page.header.participant-id.label</span>:&nbsp;{{
            participantIdString
          }}</b
        >
      </span>
    </div>
    <div fxFlex="100%" class="border-bottom-blue" style="margin-top: 16px"></div>
  </div>
</ng-template>

<ng-template #homePageMessagesFlexColumnTemplate>
  <div fxFlex="5%" fxHide.lt-md></div>
  <!-- Welcome Messages -->
  <div
    fxFlex="90%"
    fxLayoutAlign="center center"
    ngStyle.lt-md="padding-left: 8px; padding-right: 8px"
    class="large-paragraph-pre-spacing"
    *ngIf="showWelcomeMessagesSpinner"
  >
    <mat-spinner color="accent" diameter="32"></mat-spinner>
  </div>
  <div
    fxFlex="90%"
    ngStyle.lt-md="padding-left: 8px; padding-right: 8px"
    class="large-paragraph-pre-spacing"
    *ngIf="!showWelcomeMessagesSpinner && this.welcomeMessageList.length > 0"
  >
    <div
      markdown
      [data]="item.messageText"
      ngStyle.gt-sm="padding-left: 24px; padding-right: 24px"
      ngStyle.lt-md="padding-left: 8px; padding-right: 8px"
      class="message-text extra-large-display-text normal-paragraph-spacing center-text"
      [ngClass]="getMessageCssClass(item)"
      *ngFor="let item of this.welcomeMessageList"
    ></div>
  </div>
  <!-- Button Options -->


  
  <div
    fxFlex="90%"
    fxLayout.lt-sm="column" fxLayoutAlign.lt-sm="start stretch"
    fxLayoutAlign="center center"
    ngStyle.lt-sm="padding-left: 48px; padding-right: 48px"
    class="normal-paragraph-spacing center-text"
    *ngIf="!showWelcomeMessagesSpinner"
  >
    <button
      mat-flat-button
      color="primary"
      [ngClass]="{ 'home-button': media.isActive('gt-sm'), 'home-button-mobile': media.isActive('lt-md') }"
      (click)="openPayNow()"
    >
      <mat-icon [ngClass]="{ 'home-button-icon': media.isActive('gt-sm'), 'home-button-mobile-icon': media.isActive('lt-md') }"
        >attach_money</mat-icon
      >&nbsp;<span i18n="@@home-page.pay-now-button.label">home-page.pay-now-button.label</span></button
    >&nbsp;&nbsp;
    <button
      mat-flat-button
      color="primary"
      [ngClass]="{ 'home-button': media.isActive('gt-sm'), 'home-button-mobile': media.isActive('lt-md') }"
      (click)="openEsignDetails()"
    >
      <mat-icon [ngClass]="{ 'home-button-icon': media.isActive('gt-sm'), 'home-button-mobile-icon': media.isActive('lt-md') }"
        >edit</mat-icon
      >&nbsp;<span i18n="@@home-page.esign-details-button.label">home-page.esign-details-button.label</span></button
    >&nbsp;&nbsp;
    <button
      mat-flat-button
      color="primary"
      [ngClass]="{ 'home-button': media.isActive('gt-sm'), 'home-button-mobile': media.isActive('lt-md') }"
      (click)="openAutoPay()"
    >
      <mat-icon [ngClass]="{ 'home-button-icon': media.isActive('gt-sm'), 'home-button-mobile-icon': media.isActive('lt-md') }"
        >autorenew</mat-icon
      >&nbsp;<span i18n="@@home-page.auto-pay-button.label">home-page.auto-pay-button.label</span></button
    >&nbsp;&nbsp;
    <button
      mat-flat-button
      color="primary"
      [ngClass]="{ 'home-button': media.isActive('gt-sm'), 'home-button-mobile': media.isActive('lt-md') }"
      (click)="openLoanDetails()"
    >
      <mat-icon [ngClass]="{ 'home-button-icon': media.isActive('gt-sm'), 'home-button-mobile-icon': media.isActive('lt-md') }"
        >list</mat-icon
      >&nbsp;<span i18n="@@home-page.loan-details-button.label">home-page.loan-details-button.label</span>
    </button>
  </div>
  <!-- Instruction Messages -->
  <div
    fxFlex="90%"
    fxLayoutAlign="center center"
    ngStyle.lt-md="padding-left: 8px; padding-right: 8px"
    class="large-paragraph-pre-spacing"
    *ngIf="showInstructionMessagesSpinner"
  >
    <mat-spinner color="accent" diameter="32"></mat-spinner>
  </div>
  <div
    fxFlex="90%"
    ngStyle.lt-md="padding-left: 8px; padding-right: 8px"
    class="large-paragraph-pre-spacing"
    *ngIf="!showInstructionMessagesSpinner && this.instructionMessageList.length > 0"
  >
    <div
      markdown
      [data]="item.messageText"
      ngStyle.gt-sm="padding-left: 24px; padding-right: 24px"
      ngStyle.lt-md="padding-left: 8px; padding-right: 8px"
      class="message-text large-display-text normal-paragraph-spacing center-text"
      [ngClass]="getMessageCssClass(item)"
      *ngFor="let item of this.instructionMessageList"
    ></div>

    <ng-template>
      <div
        markdown
        [data]="item.messageText"
        ngStyle.gt-sm="padding-left: 24px; padding-right: 24px"
        ngStyle.lt-md="padding-left: 8px; padding-right: 8px"
        class="large-display-text normal-paragraph-spacing center-text"
        [ngClass]="getMessageCssClass(item)"
        *ngFor="let item of this.instructionMessageList"
      ></div>
    </ng-template>
  </div>
  <!-- Temporary Messages -->
  <div
    fxFlex="90%"
    fxLayoutAlign="center center"
    ngStyle.lt-md="padding-left: 8px; padding-right: 8px"
    class="large-paragraph-pre-spacing"
    *ngIf="showTemporaryMessagesSpinner"
  >
    <mat-spinner color="accent" diameter="32"></mat-spinner>
  </div>
  <div
    fxFlex="90%"
    ngStyle.lt-md="padding-left: 8px; padding-right: 8px"
    class="large-paragraph-pre-spacing"
    *ngIf="!showTemporaryMessagesSpinner && this.temporaryMessageList.length > 0"
  >
    <div
      markdown
      [data]="item.messageText"
      ngStyle.gt-sm="padding-left: 24px; padding-right: 24px"
      ngStyle.lt-md="padding-left: 8px; padding-right: 8px"
      class="message-text large-display-text normal-paragraph-spacing center-text"
      [ngClass]="getMessageCssClass(item)"
      *ngFor="let item of this.temporaryMessageList"
    ></div>
  </div>
  <!-- General Messages  Home Screen-->
  <div
    fxFlex="90%"
    fxLayoutAlign="center center"
    ngStyle.lt-md="padding-left: 8px; padding-right: 8px"
    class="large-paragraph-pre-spacing"
    *ngIf="showGeneralMessagesSpinner"
  >
    <mat-spinner color="accent" diameter="32"></mat-spinner>
  </div>
  <div
    fxFlex="90%"
    ngStyle.lt-md="padding-left: 8px; padding-right: 8px"
    class="large-paragraph-pre-spacing"
    *ngIf="!showGeneralMessagesSpinner && this.generalMessageList.length > 0"
  >
    <div
      markdown
      [data]="item.messageText"
      ngStyle.gt-sm="padding-left: 24px; padding-right: 24px"
      ngStyle.lt-md="padding-left: 8px; padding-right: 8px"
      class="message-text large-display-text normal-paragraph-spacing center-text"
      [ngClass]="getMessageCssClass(item)"
      *ngFor="let item of this.generalMessageList"
    ></div>
  </div>
  <!-- School/LoanProgram Messages -->
  <div
    fxFlex="90%"
    fxLayoutAlign="center center"
    ngStyle.lt-md="padding-left: 8px; padding-right: 8px"
    class="large-paragraph-pre-spacing"
    *ngIf="showSchoolLoanProgramMessageSpinner"
  >
    <mat-spinner color="accent" diameter="32"></mat-spinner>
  </div>
  <div
    fxFlex="90%"
    ngStyle.lt-md="padding-left: 8px; padding-right: 8px"
    class="large-paragraph-pre-spacing"
    *ngIf="!showSchoolLoanProgramMessageSpinner && this.schoolLoanProgramMessageList.length > 0"
  >
    <div
      markdown
      [data]="item.messageText"
      ngStyle.gt-sm="padding-left: 24px; padding-right: 24px"
      ngStyle.lt-md="padding-left: 8px; padding-right: 8px"
      class="message-text large-display-text normal-paragraph-spacing center-text"
      [ngClass]="getMessageCssClass(item)"
      *ngFor="let item of this.schoolLoanProgramMessageList"
    ></div>
  </div>
  <div fxFlex="5%" fxHide.lt-md></div>
</ng-template>

<ng-template #homePageFooterFlexColumnTemplate>
  <div fxLayout="column"><div fxFlex="100%" class="normal-paragraph-spacing normal-paragraph-pre-spacing"></div></div>
</ng-template>
